import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { defineCustomElements as defineCustomElementsFromUnhide } from '@frontend/web-components/loader';
import { defineCustomElements as defineCustomElementsFromPuzzl } from 'puzzl-components/dist/stencil/loader';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.error(err));

defineCustomElementsFromUnhide();
defineCustomElementsFromPuzzl();
